import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Intercepta respostas de erro em que o servidor está indisponível
 * (status === 0, ou seja, sem resposta da API) e substitui a mensagem
 * padrão do PO UI ("Servidor não está respondendo") por uma mensagem
 * mais clara para o usuário, indicando indisponibilidade do serviço.
 *
 * Este interceptor deve ser registrado APÓS o `PoModule` em
 * `app.module.ts`, garantindo que ele esteja "mais interno" na cadeia
 * de interceptors e processe o erro antes do interceptor do PO UI.
 */
@Injectable()
export class PoServerErrorInterceptor implements HttpInterceptor {
  private static readonly MENSAGEM =
    'Serviço temporariamente indisponível. Entre em contato com a equipe PJUS para verificar o status do sistema.';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 0) {
          // Reescreve o erro com status 503 e um corpo no formato esperado
          // pelo PoHttpInterceptor (code/message/detailedMessage),
          // para que ele exiba a nossa mensagem em vez do literal padrão.
          const novoErro = new HttpErrorResponse({
            status: 503,
            statusText: 'Service Unavailable',
            url: error.url || undefined,
            headers: error.headers,
            error: {
              code: 503,
              message: PoServerErrorInterceptor.MENSAGEM,
              type: 'error'
            }
          });
          return throwError(novoErro);
        }
        return throwError(error);
      })
    );
  }
}

